import { Select } from 'components'
import { useArcTranslation } from 'hooks'
import { ALL_STUDENTS, type StudentFilter, type TrackerStudent } from './types'

interface StudentSelectorProps {
  readonly students: readonly TrackerStudent[]
  readonly value: StudentFilter
  readonly onChange: (next: StudentFilter) => void
  readonly disabled?: boolean
}

const SELECTOR_WIDTH = 320

export const StudentSelector = ({ students, value, onChange, disabled }: StudentSelectorProps) => {
  const { t } = useArcTranslation()
  const sorted = [...students].sort((a, b) => a.fullName.localeCompare(b.fullName))
  const data = [
    { value: ALL_STUDENTS, label: t('arc_development_tracker.all_students') },
    ...sorted.map(s => ({ value: s.id, label: s.fullName })),
  ]

  return (
    <Select
      label={t('arc_development_tracker.student_label')}
      placeholder={t('arc_development_tracker.select_student_placeholder')}
      data={data}
      value={value}
      onChange={next => onChange(next ?? ALL_STUDENTS)}
      disabled={disabled}
      searchable
      nothingFound={t('arc_development_tracker.no_student_match')}
      style={{ width: SELECTOR_WIDTH }}
    />
  )
}
